// extracted by mini-css-extract-plugin
module.exports = {"blog":"post-module--blog--3aZRj","title":"post-module--title--_4a8P","date":"post-module--date--1UNPk","emoji":"post-module--emoji--2O8Xv"};